import '../styles/Pricing.css';

const plans = [
  {
    name: 'Başlangıç',
    price: '7.499',
    period: 'aylık + KDV',
    features: [
      '2 Sosyal Medya Platformu',
      'Aylık 12 Premium İçerik',
      'Temel Reklam Yönetimi',
      'Aylık Performans Raporu',
      'E-posta Desteği',
      'Meta Reklam Desteği'
    ],
    cta: 'Başla',
    featured: false,
  },
  {
    name: 'Profesyonel',
    price: '14.990',
    period: 'aylık + KDV',
    badge: 'En Popüler',
    features: [
      '4 Sosyal Medya Platformu',
      'Aylık 24 İçerik + Reels',
      'Gelişmiş Reklam Stratejisi',
      'Haftalık Raporlama',
      'WhatsApp Öncelikli Destek',
      'Influencer İşbirliği',
      'Meta Reklam Desteği'
    ],
    cta: 'Hemen Başla',
    featured: true,
  },
  {
    name: 'Kurumsal',
    price: null,
    period: 'markanıza özel fiyat',
    features: [
      'Sınırsız Platform Yönetimi',
      'Sınırsız İçerik Üretimi',
      'Dedike Hesap Yöneticisi',
      'Günlük Raporlama',
      '7/24 Öncelikli Destek',
      'Kriz Yönetimi Dahil',
      'Meta Reklam Desteği'
    ],
    cta: 'Teklif Al',
    featured: false,
  },
];

export default function Pricing() {
  return (
    <section className="pricing" id="paketler">
      <div className="pricing__head">
        <span className="label">Fiyatlandırma</span>
        <h2 className="section-title">İhtiyacınıza Uygun<br />Paket</h2>
        <p className="pricing__sub">
          Her ölçekteki işletme için esnek ve şeffaf fiyatlandırma.
        </p>
      </div>

      <div className="pricing__grid">
        {plans.map((p, i) => (
          <div
            key={i}
            className={`plan ${p.featured ? 'plan--featured' : ''}`}
          >
            {p.badge && <span className="plan__badge">{p.badge}</span>}
            <span className="plan__name">{p.name}</span>

            <div className="plan__price-wrap">
              {p.price ? (
                <>
                  <span className="plan__currency">₺</span>
                  <span className="plan__price">{p.price}</span>
                </>
              ) : (
                <span className="plan__price plan__price--custom">Özel</span>
              )}
            </div>
            <span className="plan__period">{p.period}</span>

            <hr className="plan__divider" />

            <ul className="plan__features">
              {p.features.map(f => (
                <li key={f}>
                  <svg className="plan__check" viewBox="0 0 16 16" fill="none">
                    <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.2"/>
                    <path d="M5 8l2.5 2.5L11 5.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {f}
                </li>
              ))}
            </ul>

            <a
              href="https://wa.me/905467698734"
              target="_blank"
              rel="noreferrer"
              className={`plan__btn ${p.featured ? 'plan__btn--featured' : ''}`}
            >
              {p.cta}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
